module.exports = __webpack_public_path__ + "static/media/selecao-bravecto-palpite.5fb954d2.webp";